<div fxLayout="column" class="list-payforms">
  <div fxLayout="row" fxLayoutAlign="start center" class="list-payforms__header">
    <payforms-filter-chips fxFlex=""></payforms-filter-chips>
    <div fxLayoutAlign="end start">
      <button id="new-payform-button" *ngIf="(constants.accessLevel$ | async) === AccessLevel.FullAccess" mat-button=""
        color="primary" (click)="driverPayService.createNewPayform()">+ NEW PAYFORM</button>
    </div>
  </div>

  <div class="list-payforms" class="mat-elevation-z8" (keypress)="handleKeypress($event)">
    <mat-drawer-container [hasBackdrop]="false" autosize>
      <mat-card>
        <mat-card-header style="height: 56px;">
          <mat-card-title>
            <div fxLayout="row" fxLayoutAlign="space-between center" class="list-payforms-card-title">
              <h2 id="payform-heading-sic">Payforms - {{(filters$ | async)?.sicCd || 'ALL'}}</h2>
              <div class="list-payforms-card-title-buttons">
                <button id="refresh-button" mat-button mat-icon-button aria-label="Filter" (click)="refresh()"
                  matTooltip="Refresh">
                  <mat-icon matSuffix>refresh</mat-icon>
                </button>
                <button id="filter-button" mat-button mat-icon-button aria-label="Filter" (click)="drawer.toggle()"
                  matTooltip="Filter">
                  <mat-icon matSuffix>filter_list</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content class="list-payforms-card-content">
          <div class="list-payforms-card-content-wrapper">
            <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">
              <ng-container matColumnDef="empName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="list-payforms-grid-empName">Employee</th>
                <td mat-cell *matCellDef="let element" class="list-payforms-grid-empName-data">
                  <a
                    [routerLink]="['/' + RouterUriComponents.VIEW_PAYFORM, element.dsrPayformId]">{{element.empName}}</a>
                </td>
              </ng-container>
              <ng-container matColumnDef="empId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="list-payforms-grid-empId">Emp. ID</th>
                <td mat-cell *matCellDef="let element" class="list-payforms-grid-empId-data">{{element.empId}}</td>
              </ng-container>
              <ng-container matColumnDef="sic">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="list-payforms-grid-sic">SIC</th>
                <td mat-cell *matCellDef="let element">{{element.sic}}</td>
              </ng-container>
              <ng-container matColumnDef="shiftStartDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="list-payforms-grid-shift">Shift Start Date
                </th>
                <td mat-cell *matCellDef="let element">{{element.shiftStartDate}}</td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="list-payforms-grid-status">Status</th>
                <td [ngClass]="{'list-payforms-grid-status-returned': element.status === 'Returned'}" mat-cell
                  *matCellDef="let element">{{element.status}}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <div fxLayout="row" fxLayoutAlign="center center" class="list-payforms-grid-nodata"
              *ngIf="!dataSource || !dataSource.data || dataSource.data.length === 0">
              No records currently match your search criteria. Please expand your search or try again.
            </div>
          </div>
          <xpo-utils-paginator></xpo-utils-paginator>
        </mat-card-content>
      </mat-card>
      <mat-drawer mat-elevation-z8 #drawer class="list-payforms-sidenav" mode="over" position="end">
        <h2>Filter</h2>
        <mat-form-field class="list-payforms-sidenav-sic">
          <input id="sic-input" matInput autocomplete="off" placeholder="SIC" maxlength="3" [(ngModel)]="sic"
            class="list-payforms-sidenav-sic-input" required minlength="3" sicValidator (blur)="sicBlur()"
            #sicInput="ngModel">
          <mat-error *ngIf="sicInput.errors">
            <div *ngIf="sicInput.errors['required']">Required</div>
            <div *ngIf="sicInput.errors['invalidLocation'] || sicInput.errors['minlength']">Invalid SIC</div>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="list-payforms-sidenav-employee">
          <input id="employee-input" matInput autocomplete="off" placeholder="Employee Name or ID" maxlength="50"
            [(ngModel)]="employeeName" #employeeNameInput="ngModel" [matAutocomplete]="auto" (blur)="employeeNameBlur()"
            class="list-payforms-sidenav-employee-input">
          <button id="clear-employee-input-button" mat-button *ngIf="employeeNameInput.value && !searching" matSuffix
            mat-icon-button aria-label="Clear Employee Name" (click)="clearEmployeeName()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-error *ngIf="employeeNameInput.errors">
            <div *ngIf="employeeNameInput.errors['not-found']">{{employeeNameInput.errors['not-found']}}</div>
          </mat-error>
          <span *ngIf="searching" class="spinner"></span>
          <mat-autocomplete id="employe-autocomplete" #auto="matAutocomplete">
            <mat-option *ngFor="let employee of (employeeList$ | async)"
              value="{{employee.fullName}} ({{employee.employeeId}})">
              {{employee.fullName}} ({{employee.employeeId}})
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <mat-form-field class="list-payforms-sidenav-from">
            <input id="date-from-input" matInput autocomplete="off" [matDatepicker]="pickerFrom"
              [notGreaterThanDate]="dateToInput" placeholder="Date From" [(ngModel)]="dateFrom"
              #dateFromInput="ngModel">
            <mat-error>
              <div *ngIf="dateFromInput.hasError('greaterThanOther')">{{dateFromInput.getError('greaterThanOther')}}
              </div>
              <div *ngIf="!dateFromInput.hasError('greaterThanOther') && dateFromInput.invalid">Invalid</div>
            </mat-error>
            <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
            <mat-datepicker #pickerFrom></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="list-payforms-sidenav-to">
            <input id="date-to-input" matInput autocomplete="off" [matDatepicker]="pickerTo"
              [notLessThanDate]="dateFromInput" placeholder="Date To" [(ngModel)]="dateTo" #dateToInput="ngModel">
            <mat-error>
              <div *ngIf="dateToInput.hasError('lessThanOther')">{{dateToInput.getError('lessThanOther')}}</div>
              <div *ngIf="!dateToInput.hasError('greaterThanOther') && dateToInput.invalid">Invalid</div>
            </mat-error>
            <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
            <mat-datepicker #pickerTo></mat-datepicker>
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" class="list-payforms-sidenav-status">
          <h2>Status</h2>
          <span>(Select one to many)</span>
        </div>
        <section fxLayout="column" class="list-payforms-sidenav-checkboxes">
          <mat-checkbox id="status-all-checkbox" (change)="statusChange('ALL', $event)" [(ngModel)]="statusAll">All
            Statuses</mat-checkbox>
          <mat-checkbox id="status-submitted-checkbox" (change)="statusChange(payformStatusCode.SUBMITTED, $event)"
            [(ngModel)]="statusSubmitted">Submitted</mat-checkbox>
          <mat-checkbox id="status-approved-checkbox" (change)="statusChange(payformStatusCode.APPROVED, $event)"
            [(ngModel)]="statusApproved">Approved</mat-checkbox>
          <mat-checkbox id="status-returned-checkbox" (change)="statusChange(payformStatusCode.RETURNED, $event)"
            [(ngModel)]="statusReturned">Returned</mat-checkbox>
          <mat-checkbox id="status-not-submitted-checkbox" (change)="statusChange(payformStatusCode.NEW, $event)"
            [(ngModel)]="statusNotSubmitted">Not Submitted</mat-checkbox>
          <mat-checkbox id="status-deleted-checkbox" (change)="statusChange(payformStatusCode.DELETED, $event)"
            [(ngModel)]="statusDeleted">Deleted</mat-checkbox>
        </section>
        <div fxLayout="row" fxLayoutAlign="end center" class="list-payforms-sidenav-actionbuttons">
          <button id="cancel-button" mat-button color="primary" (click)="cancelClicked()"
            id="sidenav-cancel">Cancel</button>
          <button id="done-button" mat-raised-button color="primary" (click)="doneClicked()"
            [disabled]="!sicInput.valid || !employeeNameInput.valid || !dateFromInput.valid || !dateToInput.valid || searching"
            id="sidenav-done">Done</button>
        </div>
      </mat-drawer>
    </mat-drawer-container>
  </div>
</div>